import React from 'react';

interface IProps {
  className?: string;
}

const Logo = ({ className }: IProps) => (
  <svg
    className={className}
    width="168"
    height="20"
    viewBox="0 0 168 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.2549 0V2.68505H55.6397V8.6595H42.4815V2.68505H46.8702V0H26.3245V2.68505H30.543L25.591 16.4307L20.412 2.68505H24.1281V0H13.8957V2.68505H17.7942L12.6152 16.4307L7.66312 2.68505H11.6953V0H0V2.68505H4.43334L11.0145 20H14.0173L19.1031 6.55041L24.1889 20H27.1917L33.7688 2.68505H39.5597V17.3149H35.175V20H46.8702V17.3149H42.4815V11.3405H55.6397V17.3149H51.2549V20H62.9502V17.3149H58.5655V2.68505H62.9502V0H51.2549Z"
      fill="white"
    />
    <path
      d="M65.1547 0V2.68505H69.5435V17.3149H65.1547V20H88.5493V11.4622H85.6235V17.3149H72.4653V11.3405H78.3129V14.3906H81.2387V5.60942H78.3129V8.6595H72.4653V2.68505H85.6235V8.53783H88.5493V0H65.1547Z"
      fill="white"
    />
    <path
      d="M91.4711 0V2.68505H95.8599V17.3149H91.4711V20H114.866V11.4622H111.94V17.3149H98.7817V11.3405H104.629V14.3906H107.555V5.60942H104.629V8.6595H98.7817V2.68505H111.94V8.53783H114.866V0H91.4711Z"
      fill="white"
    />
    <path
      d="M138.256 17.3149H125.098V2.68505H132.409V0H117.787V2.68505H122.176V17.3149H117.787V20H141.182V11.4622H138.256V17.3149Z"
      fill="white"
    />
    <path
      d="M152.877 0V2.68505H158.551L151.414 10.3752L144.278 2.68505H149.951V0H135.33V2.68505H140.449L149.951 12.9264V17.3149H144.104V20H158.725V17.3149H152.877V12.9264L162.38 2.68505H167.494V0H152.877Z"
      fill="white"
    />
  </svg>
);

export { Logo };
